import React, { Fragment, useContext, useState } from "react";
import { Button, Col, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { validatePassword } from "../../commonData";
import Password from "../inputs/Password";
import $ from "jquery";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";

const UserChangePassword = () => {
    const { t } = useTranslation();
    const initData = { oldPassword: "", newPassword: "", repeatPassword: "" };
    const [account, setAccount] = useState(initData);
    const { setAlerts, checkServerData } = useContext(BasicContext);
    const [blockForm, setBlockForm] = useState(false);
    const [formChanged, setFormChanged] = useState(false);

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (account.oldPassword.length === 0 || !account.oldPassword.replace(/\s+/, "")) {
            $("#accountOldPassword").addClass("is-invalid");
            errors.push(t("error.emptyOldPassword"));
        }
        if (account.newPassword.length === 0 || !account.newPassword.replace(/\s+/, "")) {
            $("#accountPassword").addClass("is-invalid");
            errors.push(t("error.emptyFirstPassword"));
        } else if (!validatePassword(account.newPassword)) {
            $("#accountPassword").addClass("is-invalid");
            errors.push(t("error.invalidPassword"));
        }

        if (account.repeatPassword.length === 0 || !account.repeatPassword.replace(/\s+/, "")) {
            $("#accountRepeatPassword").addClass("is-invalid");
            errors.push(t("error.emptySecondPassword"));
        } else if (!validatePassword(account.repeatPassword)) {
            $("#accountRepeatPassword").addClass("is-invalid");
            errors.push(t("error.invalidPassword"));
        }

        if (account.newPassword !== account.repeatPassword) {
            $("#accountPassword").addClass("is-invalid");
            $("#accountRepeatPassword").addClass("is-invalid");
            errors.push(t("error.passwordsAreNotTheSame"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t("info.settingPassword") }]);
            setBlockForm(true);
            setPassword();
        }
    };

    const setPassword = async () => {
        const res = await postMethod("/user-change-password", { user: account });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 2000 }]);
            setAccount(initData);
            setFormChanged(false);
            $("#accountOldPassword").removeClass("is-invalid");
            $("#accountPassword").removeClass("is-invalid");
            $("#accountRepeatPassword").removeClass("is-invalid");
        }
        setBlockForm(false);
    };

    return (
        <Fragment>
            <Col xs={12} className="px-4 px-lg-2 ">
                <p className="h5 mb-2 mt-5">{t("users.changePassword")}</p>
                <p className="mb-3" style={{ fontSize: "0.875rem" }}>
                    {t("passwordHelper")}
                </p>
                <Form onSubmit={checkValidation}>
                    {/* only for disabling warning: "Password forms should have (optionally hidden) username fields for accessibility:"*/}
                    <input type="password" name="password" autoComplete="username password" style={{ display: "none" }} />
                    <Form.Group controlId="accountOldPassword">
                        <div className="mb-3">
                            <Password
                                autoComplete="new-account.password"
                                value={account.oldPassword}
                                onChange={(e) => {
                                    setAccount({ ...account, oldPassword: e.target.value });
                                    setFormChanged(true);
                                    $("#accountOldPassword").removeClass("is-invalid");
                                }}
                                disabled={blockForm}
                                btnID="showPass"
                                label={t("oldPassword")}
                            />
                        </div>
                    </Form.Group>
                    <Form.Group controlId="accountNewPassword">
                        <div className="mb-3">
                            <Password
                                autoComplete="new-account.password"
                                value={account.newPassword}
                                onChange={(e) => {
                                    setAccount({ ...account, newPassword: e.target.value });
                                    setFormChanged(true);
                                    $("#accountNewPassword").removeClass("is-invalid");
                                }}
                                disabled={blockForm}
                                btnID="showPass"
                                label={t("newPassword")}
                            />
                        </div>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="accountRepeatPassword">
                        <Password
                            autoComplete="new-password2"
                            value={account.repeatPassword}
                            onChange={(e) => {
                                setAccount({ ...account, repeatPassword: e.target.value });
                                setFormChanged(true);
                                $("accountRepeatPassword").removeClass("is-invalid");
                            }}
                            disabled={blockForm}
                            label={t("repeatPassword")}
                            btnID="repeatPass"
                            rpp
                        />
                    </Form.Group>

                    <Button type="submit" disabled={blockForm || !formChanged}>
                        {t("saveChanges")}
                    </Button>
                </Form>
            </Col>
        </Fragment>
    );
};

export default UserChangePassword;
